import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)
// Modules
import servicesAndSettings from '@/store/modules/servicesAndSettings.js'
import workspaces from '@/store/modules/workspaces.js'
import timeslots from '@/store/modules/timeslots.js'
import error from '@/store/modules/error.js'
import location from '@/store/modules/location.js'
import payment from '@/store/modules/payment'


export default new Vuex.Store({
  modules: {
    servicesAndSettings,
    workspaces,
    timeslots,
    error,
    location,
    payment,
  },
  strict: process.env.DEV,
})
